export default __webpack_public_path__ + "static/media/gen-ai-2024.6a7f22d8.jpg";